module.exports = __webpack_public_path__ + "static/media/amit.db783c96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amit.jpg
// module id = 65
// module chunks = 0